import { networkActionsCreator } from '../../../../admincore'

const actions = {
  ...networkActionsCreator('login'),
}

export default actions

export function load(params) {
  return {
    type: actions.LOAD,
    payload: {
      params,
    },
  }
}
